/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gads_Customer_IdInputs */

const cs_integrations_gads_customer_id = /** @type {(inputs: Integrations_Gads_Customer_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer ID`)
};

const en_integrations_gads_customer_id = /** @type {(inputs: Integrations_Gads_Customer_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer ID`)
};

/**
* | output |
* | --- |
* | "Customer ID" |
*
* @param {Integrations_Gads_Customer_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gads_customer_id = /** @type {((inputs?: Integrations_Gads_Customer_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gads_Customer_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gads_customer_id(inputs)
	return cs_integrations_gads_customer_id(inputs)
});